// Browser stand-in for the `electron` module. The renderer mostly talks to
// Electron through the preload bridge (`window.api`, shimmed separately in
// src/preload-web.ts); this covers the handful of direct imports.
const { EventEmitter } = require("events");

class IpcRendererShim extends EventEmitter {
    send(channel) {
        console.debug(`[web-shim] ipcRenderer.send(${channel}) ignored`);
    }
    sendSync(channel) {
        console.debug(`[web-shim] ipcRenderer.sendSync(${channel}) ignored`);
        return undefined;
    }
    sendTo() {}
    postMessage() {}
    invoke(channel) {
        console.debug(`[web-shim] ipcRenderer.invoke(${channel}) ignored`);
        return Promise.resolve(undefined);
    }
}

const ipcRenderer = new IpcRendererShim();
ipcRenderer.setMaxListeners(0);

const webFrame = {
    setZoomFactor: (factor) => {
        document.documentElement.style.setProperty("zoom", String(factor));
    },
    getZoomFactor: () => 1,
    setZoomLevel: () => {},
    getZoomLevel: () => 0,
    setVisualZoomLevelLimits: () => {},
};

const clipboard = {
    writeText: (text) => {
        if (navigator.clipboard !== undefined) {
            navigator.clipboard.writeText(text).catch(() => undefined);
        }
    },
    // electron's readText is synchronous, the browser API is not; reading the
    // clipboard is fused off
    readText: () => "",
    writeImage: () => {},
};

const shell = {
    openExternal: (url) => {
        window.open(url, "_blank", "noopener");
        return Promise.resolve();
    },
    openPath: () =>
        Promise.resolve(
            "opening local paths is not available in the web build",
        ),
    showItemInFolder: () => {},
    trashItem: () =>
        Promise.reject(new Error("not available in the web build")),
};

const nativeImage = {
    createFromPath: () => makeEmptyImage(),
    createFromDataURL: (url) => makeImageFromDataUrl(url),
    createFromBuffer: () => makeEmptyImage(),
    createEmpty: () => makeEmptyImage(),
};

function makeEmptyImage() {
    return {
        isEmpty: () => true,
        toDataURL: () => "",
        toPNG: () => new Uint8Array(),
        getSize: () => ({ width: 0, height: 0 }),
        resize: () => makeEmptyImage(),
    };
}

function makeImageFromDataUrl(url) {
    return { ...makeEmptyImage(), isEmpty: () => false, toDataURL: () => url };
}

const webUtils = {
    // used by drag&drop handling to map a dropped File to a filesystem path;
    // no such thing in a browser
    getPathForFile: () => "",
};

const contextBridge = {
    exposeInMainWorld: (key, value) => {
        window[key] = value;
    },
};

const dialog = undefined; // renderer code falls back to window.api.dialog
const app = undefined; // util/electron.ts substitutes its own app shim

module.exports = {
    ipcRenderer,
    webFrame,
    clipboard,
    shell,
    nativeImage,
    webUtils,
    contextBridge,
    dialog,
    app,
    remote: undefined,
    ipcMain: undefined,
};
